import { mapState } from 'vuex';
import { localizeDate } from '@/utils/date';
import formMixin from '../formMixin';
const defaultItemsPerPage = 15;
export default {
  name: 'NiotaClassicConsumersIpWhiteList',
  mixins: [formMixin],
  props: {
    ips: {
      type: Array,
      required: true
      //default: () => [],
    },
    dense: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      lclObject: {},
      dialogAdd: false,
      newIpAddress: null,
      isFetching: null,
      tableOptions: {
        itemsPerPage: defaultItemsPerPage
      },
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      },
      ipRules: [v => !!v || this.$i18n_t('NiotaClassic.Consumers.itemIsRequired', {
        item: 'IP'
      }), v => /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(v) || this.$i18n_t('NiotaClassic.Consumers.errorHintInvalidIp')],
      updateIp: false,
      updatedIpIndex: null,
      isValidIp: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    tableHeaders() {
      return [{
        text: this.$i18n_t('NiotaClassic.Consumers.ipWhiteList'),
        value: 'ip',
        align: 'left'
      }, ...(this.isIotHubManager ? [{
        align: 'end',
        sortable: false
      }] : [])];
    }
  },
  methods: {
    localizeDate,
    deleteLine(ip) {
      let editedIndex = this.ips.indexOf(ip);
      this.ips.splice(editedIndex, 1);
    },
    addItem() {
      if (!this.ips) {
        this.ips = [];
      }
      this.ips.push(this.newIpAddress);
      this.dialogAdd = false;
    },
    editItem(ip) {
      this.initIp();
      this.updateIp = true;
      this.updatedIpIndex = this.ips.indexOf(ip);
      this.newIpAddress = ip;
      this.dialogAdd = true;
    },
    updateItem() {
      // delete it
      this.ips.splice(this.updatedIpIndex, 1);
      // add it to the same index
      this.ips.splice(this.updatedIpIndex, 0, this.newIpAddress);
      this.closeIpDialog();
    },
    closeIpDialog() {
      this.dialogAdd = false;
      this.initIp();
    },
    initIp() {
      this.updateIp = false;
      this.newIpAddress = null;
      this.updatedIpIndex = null;
    },
    updateOrAddItem(item) {
      return this.updateIp ? this.updateItem(item) : this.addItem(item);
    },
    handleSubmit() {
      this.isValidIp = this.$refs.form.validate();
      if (this.isValidIp) {
        this.updateOrAddItem();
      }
    }
  }
};